import type { RecordOf } from 'immutable';

import * as types from './reportConfigurationsTypes';

export function transformReportConfigurationToRequestData(
  reportConfiguration: types.ReportConfiguration | types.ReportConfigurationProps,
) {
  return {
    id: reportConfiguration.id,
    clientId: reportConfiguration.clientId,

    name: reportConfiguration.name,
    description: reportConfiguration.description,

    reportType: reportConfiguration.reportType,
    reportSubType: reportConfiguration.reportSubType,
    accountingType: reportConfiguration.accountingType,

    dateRange: reportConfiguration.dateRange,
    startOn: reportConfiguration.startOn,
    endOn: reportConfiguration.endOn,

    columnType: reportConfiguration.columnType,
    rowType: reportConfiguration.rowType,
    timestep: reportConfiguration.timestep,

    filterId: reportConfiguration.filterId,
    filter: reportConfiguration.filter,

    isDeleted: reportConfiguration.isDeleted,
  };
}

type RequestDataArray = Array<ReturnType<typeof transformReportConfigurationToRequestData>>;

export function transformReportConfigurationsToRequestData(
  resourceConfigurations: Array<types.ReportConfiguration | types.ReportConfigurationProps>,
) {
  const resources = resourceConfigurations.reduce<RequestDataArray>((list, resourceConfiguration) => {
    list.push(transformReportConfigurationToRequestData(resourceConfiguration));
    return list;
  }, []);

  return {
    resources,
  };
}

export function transformResponseToReportConfigurations(
  response?: { data?: { resources?: types.ReportConfigurationProps[] } } | null,
): RecordOf<types.ReportConfigurationProps>[] | null | undefined {
  return response?.data?.resources?.map((data) =>
    types.mkReportConfiguration({
      id: data.id,
      clientId: data.clientId,

      name: data.name,
      description: data.description,

      reportType: data.reportType,
      reportSubType: data.reportSubType,
      dateRange: data.dateRange,

      columnType: data.columnType,
      rowType: data.rowType,
      timestep: data.timestep,

      filterId: data.filterId,

      isDeleted: data.isDeleted,
      modifiedAt: data.modifiedAt,
    }),
  );
}

// export function transformResponseToReport(response: any) {
//   const data = response.data.resources ? response.data.resources[0] : response.data;
//   // const rows1 = data.rows.map((row) => transformReponseRowToReportRow(row, 'RowSet1-'));
//   // const rows2 = data.rows.map((row) => transformReponseRowToReportRow(row, 'RowSet2-'));
//   // const rows3 = data.rows.map((row) => transformReponseRowToReportRow(row, 'RowSet3-'));
//   // const rows4 = data.rows.map((row) => transformReponseRowToReportRow(row, 'RowSet4-'));
//   // const rows5 = data.rows.map((row) => transformReponseRowToReportRow(row, 'RowSet5-'));
//   // const rows = rows1.concat(rows2, rows3, rows4, rows5);
//
//   const rows = data.rows.map((row: any) => transformReponseRowToReportRow(row, ''));
//
//   return types.mkReport({
//     reportType: data.reportType,
//     rowType: data.rowType,
//     columnType: data.columnType,
//     columns: List(data.columns.map((column: any) => transformReponseColumnToReportColumn(column, data))),
//     rows: List(rows),
//   });
// }
